import { inject } from 'vue'

export const clientCategoriesKey = 'setClientCategories'

/**
 * 获取客户端左侧分类设置方法，由 ClientLayout 统一提供。
 */
export function useClientCategories() {
  const setClientCategories = inject(clientCategoriesKey, null)

  return function setCategories(categories) {
    if (setClientCategories) {
      setClientCategories(categories)
    }
  }
}
